<template>
  <tg-layout :headerHeight="120">
    <template slot="header">
      <el-row type="flex" justify="space-between">
        <TgSearchTool
          @on-submit="handleSearch"
          :disabled="!searchData.targetName"
        >
          <el-input
            :placeholder="$t('column.l10_account')"
            v-model="searchData.targetName"
            class="tg-input input-search-username"
            size="small"
            clearable
          ></el-input>
        </TgSearchTool>
      </el-row>
      <el-row style="padding: 5px">
        <!-- 平台選擇按鈕 -->
        <ThirdPartySearchBtn
          :style="{ display: showThirdParty ? 'initial' : 'none' }"
          @click.native="showThirdPartyCheckBoxDialog"
        ></ThirdPartySearchBtn>
        <ThirdPartyPlatform
          :style="{ display: showThirdParty ? 'initial' : 'none' }"
          v-model="thirdPartyData"
          @on-change="handleSearchThirdParty"
        ></ThirdPartyPlatform>
      </el-row>
    </template>
    <TgTable
      v-if="!showNodata"
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      @on-loaded="handleLoaded"
      showPagination
    >
      <!-- 盈虧明細 -->
      <template slot="goto_detail" slot-scope="scope">
        <router-link
          :class="{
            'text-red': Number(scope.row.result) < 0,
            'text-green': Number(scope.row.result) > 0,
          }"
          :to="{
            name: 'accounts.member_monthly_profit.detail',
            query: {
              date: scope.row['date'],
              targetName: searchData.targetName,
            },
            params: { third_party: searchData.third_party },
          }"
        >
          {{ scope.row.result }}
        </router-link>
        <!-- DBE925 -->
      </template>
    </TgTable>
    <template v-if="showNodata">
      <div class="tg-bg-white">
        <TgNodata :isNeedSearch="!isSearch"></TgNodata>
      </div>
    </template>

    <!-- 平台篩選彈窗 -->
    <ThirdPartyCheckBoxDialog
      ref="thirdPartyCheckBoxDialog"
      :third_party="thirdPartyData"
      @on-click="handleSearchThirdParty"
    ></ThirdPartyCheckBoxDialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import ThirdPartySearchBtn from "@/components/button/ThirdPartySearchBtn";
import ThirdPartyPlatform from "@/components/tool/ThirdPartyPlatform";
import ThirdPartyCheckBoxDialog from "@/components/dialog/ThirdPartyCheckBoxDialog";
import TgTable from "@/components/table/TgTable";
import TgNodata from "@/components/TgNodata";
import apis from "@/apis";

const api = apis.accounts.member_monthly_profit;
const STORE_UPDATE = "pages/accounts/memberMonthlyProfit/update";

export default {
  components: {
    TgLayout,
    TgSearchTool,
    ThirdPartySearchBtn,
    ThirdPartyPlatform,
    ThirdPartyCheckBoxDialog,
    TgTable,
    TgNodata,
  },
  data() {
    return {
      columns: [],
      proxy: api.getData,
      searchData: {
        targetName: "",
      },
      reload: false,
      isSearch: false,
      showNodata: true,
      hasData: false,
    };
  },
  computed: {
    thirdPartyData: {
      get() {
        return this.$store.state.pages.accounts.memberMonthlyProfit
          .thirdPartyData;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE, { thirdPartyData: val });
      },
    },
  },
  created() {
    const nameFromQuery = this.$route.query.targetName;
    this.searchData.targetName = nameFromQuery ? nameFromQuery : "";
    this.$store.commit("breadcrumb/clear");
    api.getColumns().then((response) => {
      this.columns = response.data.columns;
    });
  },
  methods: {
    async handleSearchThirdParty(value) {
      this.thirdPartyData = value;
      this.platforms = this.thirdPartyData.map((r) => {
        return r.platform;
      });

      await this.handleSearch();
    },
    showThirdPartyCheckBoxDialog() {
      this.$refs.thirdPartyCheckBoxDialog.showDialog();
    },
    // 查詢
    async handleSearch() {
      const params = await this.getSubmitValidate();
      if (!params) return;
      this.$router.push({
        query: {
          targetName: this.searchData.targetName,
        },
      });
      this.$nextTick(() => {
        this.$refs.table.search(params);
      });
    },
    getSubmitValidate() {
      if (this.searchData.targetName === "") {
        this.showNodata = true;
        this.isSearch = false;
        return;
      }
      this.showNodata = false;
      this.isSearch = true;
      const params = {
        ...this.searchData,
        third_party:
          this.thirdPartyData?.map((item) =>
            item.platform ? item.platform : item.key
          ) || [],
      };
      return params;
    },
    // 處理response
    handleLoaded(response) {
      if (response.retcode == 0) {
        this.hasData = response.data.length > 0;
        let columns = JSON.parse(JSON.stringify(this.columns));
        this.columns = columns;
      }
    },
  },
};
</script>
